<template>
  <div
    name="rb-radio"
    :style="cssVars"
    :class="{ 'inline': props.inline }"
  >
    <span
      style="width: 100%;"
      v-if="props.label"
    >{{ props.label }}
    </span>
    <div
      class="radio"
      v-for="(item) in props.data"
      :key="item[props.config.key]"
      @click="$emit('update:modelValue', item)"
    >
      <input
        type="radio"
        :name="props.name"
        :value="item[props.config.key]"
        :checked="props.modelValue && item[props.config.key] === props.modelValue[props.config.key]"
        :class="{ primary, secondary }"
      >
      <label>{{ item[props.config.title] }}</label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface IRadioConfig {
  key: string,
  title: string
}

defineEmits(['update:modelValue']);
const props = withDefaults(defineProps<{
  modelValue: any,
  name: string,
  data: Array<any>
  config: IRadioConfig,
  label?: string,
  color?: string,
  inline?: boolean,
  primary?: boolean,
  secondary?: boolean
}>(), {
  color: 'rgba(0, 0, 0, 0.6)',
  label: '',
  inline: false
});

const cssVars = computed(() => {
  return {
    ['--color']: props.color
  };
});
</script>

<style scoped lang="scss">
div[name="rb-radio"] {
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-indent: 0;
  }

  display: flex;
  flex-direction: column;
  gap: 16px 32px;

  &.inline {
    flex-wrap: wrap;
    flex-direction: row;
  }

  &>span {
    font-size: 1rem;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: var(--color);
  }

  .radio {
    display: flex;
    align-items: center;
    height: 20px;
    width: max-content;
    gap: 8px;

    &:hover,
    *:hover {
      cursor: pointer;
    }

    &>input {
      height: 100%;
      aspect-ratio: 1 / 1;
      accent-color: var(--color);

      &.primary {
        accent-color: var(--primary);
      }

      &.secondary {
        accent-color: var(--secondary);
      }
    }

    &>label {
      font-size: 1rem;
      line-height: 20px;
      white-space: nowrap;
    }
  }
}
</style>